/* tslint:disable */
/* eslint-disable */
/**
 * inscrib.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BuildJob
 */
export interface BuildJob {
    /**
     * 
     * @type {number}
     * @memberof BuildJob
     */
    'id': number;
    /**
     * 
     * @type {StatusEnum}
     * @memberof BuildJob
     */
    'status': StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BuildJob
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof BuildJob
     */
    'date_started': string | null;
    /**
     * 
     * @type {string}
     * @memberof BuildJob
     */
    'date_finished': string | null;
    /**
     * 
     * @type {any}
     * @memberof BuildJob
     */
    'config_snapshot': any | null;
    /**
     * 
     * @type {string}
     * @memberof BuildJob
     */
    'firmware_revision': string | null;
    /**
     * 
     * @type {number}
     * @memberof BuildJob
     */
    'config': number;
    /**
     * 
     * @type {number}
     * @memberof BuildJob
     */
    'results': number | null;
}
/**
 * 
 * @export
 * @interface BuildJobRequest
 */
export interface BuildJobRequest {
    /**
     * 
     * @type {number}
     * @memberof BuildJobRequest
     */
    'config': number;
}
/**
 * 
 * @export
 * @interface BuildJobShort
 */
export interface BuildJobShort {
    /**
     * 
     * @type {number}
     * @memberof BuildJobShort
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof BuildJobShort
     */
    'config': number;
    /**
     * 
     * @type {StatusEnum}
     * @memberof BuildJobShort
     */
    'status': StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BuildJobShort
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof BuildJobShort
     */
    'date_started': string | null;
    /**
     * 
     * @type {string}
     * @memberof BuildJobShort
     */
    'date_finished': string | null;
    /**
     * 
     * @type {number}
     * @memberof BuildJobShort
     */
    'results': number | null;
    /**
     * 
     * @type {string}
     * @memberof BuildJobShort
     */
    'firmware_revision': string | null;
}
/**
 * 
 * @export
 * @interface BuildResults
 */
export interface BuildResults {
    /**
     * 
     * @type {number}
     * @memberof BuildResults
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BuildResults
     */
    'output': string;
    /**
     * 
     * @type {string}
     * @memberof BuildResults
     */
    'firmware': string | null;
    /**
     * 
     * @type {string}
     * @memberof BuildResults
     */
    'hash': string | null;
    /**
     * 
     * @type {number}
     * @memberof BuildResults
     */
    'job': number;
}
/**
 * 
 * @export
 * @interface KeyboardConfig
 */
export interface KeyboardConfig {
    /**
     * 
     * @type {number}
     * @memberof KeyboardConfig
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfig
     */
    'owner_name': string;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfig
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof KeyboardConfig
     */
    'config': any;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfig
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfig
     */
    'date_modified': string;
    /**
     * 
     * @type {boolean}
     * @memberof KeyboardConfig
     */
    'public'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof KeyboardConfig
     */
    'owner': number | null;
}
/**
 * 
 * @export
 * @interface KeyboardConfigRequest
 */
export interface KeyboardConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfigRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfigRequest
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof KeyboardConfigRequest
     */
    'config': any;
    /**
     * 
     * @type {boolean}
     * @memberof KeyboardConfigRequest
     */
    'public'?: boolean;
}
/**
 * Serializer used in list views to avoid sending full config
 * @export
 * @interface KeyboardConfigShort
 */
export interface KeyboardConfigShort {
    /**
     * 
     * @type {number}
     * @memberof KeyboardConfigShort
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfigShort
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfigShort
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfigShort
     */
    'date_modified': string;
    /**
     * 
     * @type {number}
     * @memberof KeyboardConfigShort
     */
    'owner': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof KeyboardConfigShort
     */
    'public'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof KeyboardConfigShort
     */
    'owner_name': string;
}
/**
 * 
 * @export
 * @interface PatchedKeyboardConfigRequest
 */
export interface PatchedKeyboardConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedKeyboardConfigRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedKeyboardConfigRequest
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedKeyboardConfigRequest
     */
    'config'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedKeyboardConfigRequest
     */
    'public'?: boolean;
}
/**
 * * `P` - PENDING * `R` - RUNNING * `F` - FAILURE * `S` - SUCCESS * `C` - CACHED
 * @export
 * @enum {string}
 */

export const StatusEnum = {
    P: 'P',
    R: 'R',
    F: 'F',
    S: 'S',
    C: 'C'
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];


/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'id': number;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof User
     */
    'username': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof User
     */
    'keyboard_configs': Array<number>;
}

/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {KeyboardConfigRequest} keyboardConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configCreate: async (keyboardConfigRequest: KeyboardConfigRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyboardConfigRequest' is not null or undefined
            assertParamExists('configCreate', 'keyboardConfigRequest', keyboardConfigRequest)
            const localVarPath = `/api/firmware/config/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyboardConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('configDestroy', 'id', id)
            const localVarPath = `/api/firmware/config/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/firmware/config/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {PatchedKeyboardConfigRequest} [patchedKeyboardConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configPartialUpdate: async (id: number, patchedKeyboardConfigRequest?: PatchedKeyboardConfigRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('configPartialUpdate', 'id', id)
            const localVarPath = `/api/firmware/config/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedKeyboardConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('configRetrieve', 'id', id)
            const localVarPath = `/api/firmware/config/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {KeyboardConfigRequest} keyboardConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configUpdate: async (id: number, keyboardConfigRequest: KeyboardConfigRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('configUpdate', 'id', id)
            // verify required parameter 'keyboardConfigRequest' is not null or undefined
            assertParamExists('configUpdate', 'keyboardConfigRequest', keyboardConfigRequest)
            const localVarPath = `/api/firmware/config/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyboardConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {KeyboardConfigRequest} keyboardConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configCreate(keyboardConfigRequest: KeyboardConfigRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyboardConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configCreate(keyboardConfigRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KeyboardConfigShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {PatchedKeyboardConfigRequest} [patchedKeyboardConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configPartialUpdate(id: number, patchedKeyboardConfigRequest?: PatchedKeyboardConfigRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyboardConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configPartialUpdate(id, patchedKeyboardConfigRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyboardConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {KeyboardConfigRequest} keyboardConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configUpdate(id: number, keyboardConfigRequest: KeyboardConfigRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyboardConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configUpdate(id, keyboardConfigRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {KeyboardConfigRequest} keyboardConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configCreate(keyboardConfigRequest: KeyboardConfigRequest, options?: any): AxiosPromise<KeyboardConfig> {
            return localVarFp.configCreate(keyboardConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.configDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configList(options?: any): AxiosPromise<Array<KeyboardConfigShort>> {
            return localVarFp.configList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {PatchedKeyboardConfigRequest} [patchedKeyboardConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configPartialUpdate(id: number, patchedKeyboardConfigRequest?: PatchedKeyboardConfigRequest, options?: any): AxiosPromise<KeyboardConfig> {
            return localVarFp.configPartialUpdate(id, patchedKeyboardConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configRetrieve(id: number, options?: any): AxiosPromise<KeyboardConfig> {
            return localVarFp.configRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this keyboard config.
         * @param {KeyboardConfigRequest} keyboardConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configUpdate(id: number, keyboardConfigRequest: KeyboardConfigRequest, options?: any): AxiosPromise<KeyboardConfig> {
            return localVarFp.configUpdate(id, keyboardConfigRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     * 
     * @param {KeyboardConfigRequest} keyboardConfigRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public configCreate(keyboardConfigRequest: KeyboardConfigRequest, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).configCreate(keyboardConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this keyboard config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public configDestroy(id: number, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).configDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public configList(options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).configList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this keyboard config.
     * @param {PatchedKeyboardConfigRequest} [patchedKeyboardConfigRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public configPartialUpdate(id: number, patchedKeyboardConfigRequest?: PatchedKeyboardConfigRequest, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).configPartialUpdate(id, patchedKeyboardConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this keyboard config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public configRetrieve(id: number, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).configRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this keyboard config.
     * @param {KeyboardConfigRequest} keyboardConfigRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public configUpdate(id: number, keyboardConfigRequest: KeyboardConfigRequest, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).configUpdate(id, keyboardConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobApi - axios parameter creator
 * @export
 */
export const JobApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [hash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobByResultsHashList: async (hash?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/firmware/job/by-results-hash/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            if (hash !== undefined) {
                localVarQueryParameter['hash'] = hash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BuildJobRequest} buildJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobCreate: async (buildJobRequest: BuildJobRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildJobRequest' is not null or undefined
            assertParamExists('jobCreate', 'buildJobRequest', buildJobRequest)
            const localVarPath = `/api/firmware/job/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/firmware/job/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this build job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('jobRetrieve', 'id', id)
            const localVarPath = `/api/firmware/job/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobApi - functional programming interface
 * @export
 */
export const JobApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [hash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobByResultsHashList(hash?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildJobShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobByResultsHashList(hash, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BuildJobRequest} buildJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobCreate(buildJobRequest: BuildJobRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobCreate(buildJobRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildJobShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this build job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobApi - factory interface
 * @export
 */
export const JobApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [hash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobByResultsHashList(hash?: string, options?: any): AxiosPromise<Array<BuildJobShort>> {
            return localVarFp.jobByResultsHashList(hash, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BuildJobRequest} buildJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobCreate(buildJobRequest: BuildJobRequest, options?: any): AxiosPromise<BuildJob> {
            return localVarFp.jobCreate(buildJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobList(options?: any): AxiosPromise<Array<BuildJobShort>> {
            return localVarFp.jobList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this build job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobRetrieve(id: number, options?: any): AxiosPromise<BuildJob> {
            return localVarFp.jobRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobApi - object-oriented interface
 * @export
 * @class JobApi
 * @extends {BaseAPI}
 */
export class JobApi extends BaseAPI {
    /**
     * 
     * @param {string} [hash] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    public jobByResultsHashList(hash?: string, options?: AxiosRequestConfig) {
        return JobApiFp(this.configuration).jobByResultsHashList(hash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BuildJobRequest} buildJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    public jobCreate(buildJobRequest: BuildJobRequest, options?: AxiosRequestConfig) {
        return JobApiFp(this.configuration).jobCreate(buildJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    public jobList(options?: AxiosRequestConfig) {
        return JobApiFp(this.configuration).jobList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this build job.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    public jobRetrieve(id: number, options?: AxiosRequestConfig) {
        return JobApiFp(this.configuration).jobRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResultsApi - axios parameter creator
 * @export
 */
export const ResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id A unique integer value identifying this build results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultsRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resultsRetrieve', 'id', id)
            const localVarPath = `/api/firmware/results/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResultsApi - functional programming interface
 * @export
 */
export const ResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id A unique integer value identifying this build results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resultsRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resultsRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResultsApi - factory interface
 * @export
 */
export const ResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResultsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id A unique integer value identifying this build results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultsRetrieve(id: number, options?: any): AxiosPromise<BuildResults> {
            return localVarFp.resultsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResultsApi - object-oriented interface
 * @export
 * @class ResultsApi
 * @extends {BaseAPI}
 */
export class ResultsApi extends BaseAPI {
    /**
     * 
     * @param {number} id A unique integer value identifying this build results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultsApi
     */
    public resultsRetrieve(id: number, options?: AxiosRequestConfig) {
        return ResultsApiFp(this.configuration).resultsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCurrentRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/firmware/user/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userRetrieve', 'id', id)
            const localVarPath = `/api/firmware/user/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userCurrentRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userCurrentRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCurrentRetrieve(options?: any): AxiosPromise<User> {
            return localVarFp.userCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRetrieve(id: number, options?: any): AxiosPromise<User> {
            return localVarFp.userRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userCurrentRetrieve(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userRetrieve(id: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


